import React, { Component } from 'react';
//redux 
import { connect } from 'react-redux'
import { authenticate_firebase_user } from '../../Actions/authAction'

import {withRouter} from 'react-router-dom' 
import { getFirebaseData } from '../../Actions/FirebaseDataAction';

class LoadingComponent extends Component {
    
    componentWillMount() {
        this.props.authenticate_from_props();
        this.props.firebase_data_from_props();
    }
  
    render() { 
       
        //if the app is authenticated load the auth links
        if((this.props.is_authenticated_prop !== null) || (this.props.is_authenticated_prop === null)){
            return (
                <div className="loadingComponentdiv">
                    {this.props.children}
                </div>
            )
        }
         return (   
            <h1>Loading</h1>
         )
    }
}
 

const mapStateToProps = (state) => {
    return {

        is_authenticated_prop: state.is_authenticated.is_authenticated,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
        authenticate_from_props: () => dispatch(authenticate_firebase_user("GET_AUTH")),
        firebase_data_from_props: () => dispatch(getFirebaseData()),
    }
  }
  export default withRouter(connect(mapStateToProps, mapDispatchToProps) (LoadingComponent));
  
  



// WEBPACK FOOTER //
// ./src/Components/LoadingComponent/LoadingComponent.jsx